import { render, staticRenderFns } from "./TabProducts.vue?vue&type=template&id=eb152dea&scoped=true&"
import script from "./TabProducts.vue?vue&type=script&lang=js&"
export * from "./TabProducts.vue?vue&type=script&lang=js&"
import style0 from "./TabProducts.vue?vue&type=style&index=0&id=eb152dea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb152dea",
  null
  
)

export default component.exports